/**
 * SHA-256 em hexadecimal (WebCrypto). Assíncrono: nunca aguardar dentro de `repo.transacao`
 * (a transação do IndexedDB fecha antes; ver `PrematureCommitError` em solucao-de-problemas.md).
 */
export async function sha256(bytes: Uint8Array): Promise<string> {
  const digest = await crypto.subtle.digest('SHA-256', bytes as Uint8Array<ArrayBuffer>);
  return Array.from(new Uint8Array(digest), (b) => b.toString(16).padStart(2, '0')).join('');
}
